<template>
  <div class="patient-events__skeleton">
    <div v-for="item in 5" :key="item" class="patient-events__skeleton-item">
      <ld-skeleton width="100%" height="40px"></ld-skeleton>
      <ld-skeleton width="30%" height="10px"></ld-skeleton>
    </div>
  </div>
</template>

<script>
export default {
name: "PatientEventsWidgetSkeleton"
}
</script>

<style scoped>
  .patient-events__skeleton {
    max-height: 400px;
    display: flex;
    flex-direction: column;
  }
  .patient-events__skeleton-item {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
  }
</style>
